import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DashboardCustomizeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dashboard_customize"}/>
}
